module.exports = __webpack_public_path__ + "img/party_logo.e12ffb8b.png";